import React from 'react';
import { isHauptadmin } from '../../lib/globalData';
import { List, Edit, Datagrid, SimpleForm, TextField, useRecordContext, 
  EditButton, TextInput, Filter, ReferenceInput, SelectInput } from 'react-admin';
import CloseToolbar from '../../lib/CloseToolbar';
import NoPagination from '../../lib/NoPagination';

const ColorField = ({...props}) => {
  const record = useRecordContext();
  return (
    <TextField {...props} sx={{color: record.color, fontWeight: 600, whiteSpace: 'nowrap'}} />
  )
}

const ListForm = (props) => {
  const {classes, ...rest} = props;
  return (
    <List {...rest} title="bw.set.paymenttype.title" sort={{ field: 'pos,fpos', order: 'ASC' }} 
      exporter={isHauptadmin() && props.exporter} pagination={<NoPagination />} perPage={1000} >
      <Datagrid style={{ width: 'auto' }} bulkActionButtons={false}>
        <ColorField source="groupname" sx={{whiteSpace: 'nowrap'}} />
        <TextField source="schluessel" />
        <TextField source="bezeichnung" />
        <TextField source="wert" />
        {isHauptadmin() &&
          <TextField source="id" textAlign="right" />
        }
        <EditButton label="" />
      </Datagrid>
    </List>
  )
}

const TextFieldFormat = ({label, ...props}) => {
  return (
    <div style={{display: 'flex', marginLeft: '.7em', marginBottom: '.5em'}}>
      <div style={{width: '6.5em'}}>{label}:</div>
      <TextField {...props} sx={{mt: '.05em', fontSize: '1em'}} />
    </div>
  )
}

const CEForm = ({classes, hasList, hasEdit, hasCreate, hasShow, ...props}) => {
  return (
    <SimpleForm toolbar={<CloseToolbar noDelete />} {...props}> 
      <TextFieldFormat source="groupname" label="Gruppe" />
      <TextFieldFormat source="schluessel" label="Schlüssel" />
      <TextFieldFormat source="bezeichnung" label="Bezeichnung" />
      <TextInput source="wert" fullWidth />
      <TextField source="hilfe" sx={{ml: '.7em', fontSize: '1em'}} />
    </SimpleForm>
  )
};

const ColoredTextOption = choice => (
  <span style={{ color: choice.color, fontWeight: 600 }}>{choice.bezeichnung}</span>
);

const ListFilter = (props) => (
  <Filter {...props}>
    <ReferenceInput source="konfig_gruppe_id" reference="setTkonfig/groups" sort={{field: 'pos', order: 'ASC'}} alwaysOn>
      <SelectInput optionText={ColoredTextOption} emptyText="All" />
    </ReferenceInput>
    <TextInput source="q" alwaysOn inputProps={{ 'data-lpignore': 'true', autoComplete: 'off' }} />
  </Filter>
);

const Tkonfig = {
  list: ({ classes, ...props }) => (
    <ListForm {...props} classes={classes} filters={<ListFilter />} />
  ),
  
  edit: ({ classes, ...props }) => (
    <Edit title="bw.set.paymenttype.titleEdit" mutationMode="pessimistic" {...props}>
      <CEForm {...props} classes={classes} />
    </Edit>
  )
}   
export default Tkonfig